export enum EOrderStatusCode {
	POST_SALE_CONFIRMED = 'post_sale_confirmed',
	POST_SALE_SHIPPED = 'post_sale_shipped',
	ACCEPTED = 'accepted',
	VALIDATION_FAILED = 'validation_failed',
	FC_CONFIRMED = 'fc_confirmed',
	FC_REFUSED = 'fc_refused',
	PAYMENT_VERIFIED = 'payment_verified',
	PAYMENT_REJECTED = 'payment_rejected',
}

export enum EOrderStatusName {
	POST_SALE_CONFIRMED = 'Post Sale Confirmed',
	POST_SALE_SHIPPED = 'Post Sale Shipped',
	ACCEPTED = 'Accepted',
	VALIDATION_FAILED = 'Validation Failed',
	FC_CONFIRMED = 'FC Confirmed',
	FC_REFUSED = 'FC Refused',
	PAYMENT_VERIFIED = 'Payment Verified',
	PAYMENT_REJECTED = 'Payment Rejected',
}

export const ORDER_STATUS_FILTER: [string, string][] = [
	[EOrderStatusCode.ACCEPTED, EOrderStatusName.ACCEPTED],
	[EOrderStatusCode.FC_CONFIRMED, EOrderStatusName.FC_CONFIRMED],
	[EOrderStatusCode.FC_REFUSED, EOrderStatusName.FC_REFUSED],
	[EOrderStatusCode.PAYMENT_REJECTED, EOrderStatusName.PAYMENT_REJECTED],
	[EOrderStatusCode.PAYMENT_VERIFIED, EOrderStatusName.PAYMENT_VERIFIED],
	[EOrderStatusCode.POST_SALE_CONFIRMED, EOrderStatusName.POST_SALE_CONFIRMED],
	[EOrderStatusCode.POST_SALE_SHIPPED, EOrderStatusName.POST_SALE_SHIPPED],
	[EOrderStatusCode.VALIDATION_FAILED, EOrderStatusName.VALIDATION_FAILED],
];

export enum EOrderSchemeCode {
	IOSS_NON_UNION = 'IOSS-NON-UNION',
	IOSS_UNION = 'IOSS-UNION',
	IOSS_IMPORT = 'IOSS-IMPORT',
	FC = 'FC-REP',
	FC_SIMPLE_REP = 'FC-SIMPLE-REP',
	B2B_INTRA_COMMUNAL = 'B2B-INTRA-COMMUNAL',
	B2B_DOMESTIC = 'B2B-DOMESTIC',
	B2C_DOMESTIC = 'B2C-DOMESTIC',
	GIFTCARD_SCHEME = 'GIFTCARD_SCHEME',
	NON_EU_IMPORT = 'NON_EU_IMPORT',
	NON_EU_DOMESTIC = 'NON_EU_DOMESTIC',
	EI_FACILITATION = 'EI_FACILITATION',
}

export enum EOrderSchemeName {
	'IOSS-NON-UNION' = 'Non-Union OSS',
	'IOSS-UNION' = 'OSS',
	'IOSS-IMPORT' = 'IOSS',
	'FC-REP' = 'DDP/DDU Sales',
	// 'FC-SIMPLE-REP' = 'DDP/DDU Sale',
	'B2B-INTRA-COMMUNAL' = 'B2B',
	'B2B-DOMESTIC' = 'B2B Domestic',
	'B2C-DOMESTIC' = 'B2C Domestic',
	GIFTCARD_SCHEME = 'Gift Cards',
	NON_EU_IMPORT = 'NON EU Import',
	NON_EU_DOMESTIC = 'NON EU Domestic',
	EI_FACILITATION = 'Marketplace Sales',
}
